<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span
                        v-if="
                          lessonCatId != null &&
                          lessonCatId != '' &&
                          lessonCatId != 'new'
                        "
                        >Хичээлийн төрлийн мэдээлэл засах</span
                      >
                      <span v-else>Хичээлийн төрөл нэмэх</span>
                    </h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Нэр: </label>
                      <input
                        v-model.trim="lessonCat.name"
                        type="text"
                        class="form-control"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="нэр"
                      />
                    </div>

                    <div class="form-group">
                      <label for="exampleFormControlSelect1"
                        >Төрөл:
                        <span class="text-danger"
                          >энэxүү талбараас заавал сонголт xийx</span
                        ></label
                      >
                      <select
                        class="form-control"
                        v-model="lessonCat.typeDetail"
                      >
                        <option
                          v-for="type in types"
                          v-bind:key="'type-' + type.id"
                          v-bind:value="type"
                        >
                          {{ type.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Тайлбар: </label>

                      <textarea
                        v-model.trim="lessonCat.description"
                        class="form-control"
                      ></textarea>
                    </div>

                    <!-- <div class="form-group">
                      <label for="exampleFormControlSelect1">Сонгох /Заавал/:</label>
                      <select class="form-control" v-model='lessonCat.option'>
                        <option v-for="type in categories" v-bind:key="'cccc-'+type.id" v-bind:value="type.ref">{{type.name}} <span v-if="type.typeDetail"> - {{type.typeDetail.name}}</span></option>
                      </select>
                    </div> -->
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()"
                          >Буцах</a
                        >
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "lessonCatAdd",
  data() {
    return {
      lessonCat: {
        name: "",
      },
      performingRequest: false,
      school: null,
      schools: [],
      types: [],
      categories: [],
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    async save() {
      this.performingRequest = true;
      console.log(this.lessonCat.typeDetail)
      if (this.lessonCat.typeDetail != null && this.lessonCat.typeDetail != undefined ) {
        if (this.lessonCat != null && this.lessonCat.name != "") {
          if (this.lessonCat.typeDetail && this.lessonCat.typeDetail.ref) {
            this.lessonCat.type = this.lessonCat.typeDetail.ref;
          }
          if (
            this.lessonCat.id != null &&
            this.lessonCat.id != "" &&
            this.lessonCat.id != "new"
          ) {
            this.lessonCat.modified = fb.usersCollection.doc(
              this.$store.getters.currentUser.uid
            );
            this.lessonCat.modifiedAt = new Date();
            if (this.schoolId)
              this.lessonCat.school = fb.db
                .collection("schools")
                .doc(this.schoolId);

            fb.db
              .collection("schools/" + this.schoolId + "/categories")
              .doc(this.lessonCat.id)
              .set(this.lessonCat);
            this.$router.back();
          } else {
            var doc = await fb.db
              .collection("schools/" + this.schoolId + "/categories")
              .doc()
              .get();

            this.lessonCat.created = fb.usersCollection.doc(
              this.$store.getters.currentUser.uid
            );
            this.lessonCat.createdAt = new Date();
            var precategories = await fb.db
              .collection("schools/" + this.schoolId + "/categories")
              .get();
            if (precategories && precategories.size > 0)
              this.lessonCat.index = precategories.size + 1;

            if (this.schoolId) {
              this.lessonCat.school = fb.db
                .collection("schools")
                .doc(this.schoolId);
              fb.db
                .collection("schools")
                .doc(this.schoolId)
                .update({
                  numberOfCategories: fb.firestore.FieldValue.increment(1),
                });
            }

            await doc.ref.set(this.lessonCat);
            this.$router.back();
          }
        }else{
          var yes = confirm(
            "Xичээлийн төрлөө сонгоно уу!"
          );
        }
      }
    },
    setLessonCategory() {
      this.lessonCat = {
        name: "",
      };
    },

    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },

    async _getLessonCategory() {
      if (this.schoolId) {
        var types = await fb.db
          .collection("lessontypes")
          .orderBy("index")
          .get();
        if (types && !types.empty) {
          types.docs.forEach((value) => {
            let item = value.data();
            item.id = value.id;
            item.ref = value.ref;
            this.types.push(item);
          });
        }

        var csSnapshot = await fb.db
          .doc("schools/" + this.schoolId)
          .collection("categories")
          .orderBy("name")
          .get();
        if (csSnapshot && !csSnapshot.empty) {
          csSnapshot.docs.forEach((value) => {
            let item = value.data();
            item.id = value.id;
            item.ref = value.ref;
            this.categories.push(item);
          });
        }
      }
      if (
        this.lessonCatId != null &&
        this.lessonCatId != "" &&
        this.lessonCatId != "new"
      ) {
        var lessonCatData = await fb.db
          .collection("schools/" + this.schoolId + "/categories")
          .doc(this.lessonCatId)
          .get();
        let object = lessonCatData.data();
        object.id = lessonCatData.id;
        this.lessonCat = object;
        if (this.lessonCat.typeDetail) {
        } else this.lessonCat.typeDetail = null;
      }
    },
  },
  props: {
    lessonCatId: {
      required: false,
    },
    schoolId: {
      required: true,
    },
  },
  created() {
    this._getLessonCategory();
  },
};
</script>

